import { useMemo } from 'react'
import moment from 'moment'

import type { View } from 'modules/shift_management/lib/types'
import type { ColumnsType } from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/utils/buildColumns'

/**
 * Adapter hook that converts the new grid's view dates into ColumnsType
 * for the legacy CoverageSection component.
 *
 * CoverageSection only reads two fields from each Column:
 *   - `minWidth` (from columns[0] for the row header width)
 *   - `date` (from columns[n > 0] for date-based filtering)
 *
 * The remaining Column fields (`formattedDate`, `headerCell`, `hour`,
 * `isNextPeriod`) are stubbed with defaults since CoverageSection never
 * accesses them.
 */
export const useCoverageColumns = (view: View): ColumnsType => {
  return useMemo(() => {
    const headerColumn = {
      date: moment(),
      formattedDate: '',
      headerCell: '',
      minWidth: 's240' as const,
      hour: 0,
    }

    const dateColumns = view.dates.map((date) => ({
      date,
      formattedDate: '',
      headerCell: '',
      minWidth: view.columnMinWidth,
      hour: 0,
    }))

    return [headerColumn, ...dateColumns]
  }, [view.dates, view.columnMinWidth])
}
